import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@global/Api';

import { CANCEL_SUBSCRIPTION_CONTRACT } from '@global/requests/subscriptionDetails';
import {
  setError,
  setIsCancelled,
  setNotification,
} from '@global/store/slices/subscription/subscriptionSlice';

export const cancelSubscriptionContract = createAsyncThunk<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  {
    language?: string;
    t?: (arg: string) => string;
    subscriptionUid: string;
    cancelCode?: string;
    justification?: string;
  },
  { rejectValue }
>(
  'subscription/cancelSubscriptionContract',
  async (
    { t, subscriptionUid, cancelCode, justification },
    { rejectWithValue, dispatch }
  ) => {
    try {
      await client.mutate({
        mutation: CANCEL_SUBSCRIPTION_CONTRACT,
        variables: {
          uid: subscriptionUid,
          cancelCode,
          justification,
        },
      });

      const isCancelled = true;

      dispatch(setIsCancelled({ subscriptionUid, isCancelled }));
      dispatch(setNotification(t('notificationTexts.success.cancel')));
    } catch (err) {
      dispatch(setError(err.message));
      return rejectWithValue(t('notificationTexts.err.cancel'));
    }
  }
);
